import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface StandorteFahrzeugeJahreswerteProps {
    fahrzeugSelected: any;
}

export interface StandorteFahrzeugeJahreswerteState {
    validRestriction: string;
}

export class StandorteFahrzeugeJahreswerte extends React.Component<StandorteFahrzeugeJahreswerteProps, StandorteFahrzeugeJahreswerteState> {

    constructor(props: any) {
        super(props);
        this.state = {
            validRestriction: null
        };
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    preFilter(data: Array<any>): Array<any> {
        const { fahrzeugSelected } = this.props;

        return fahrzeugSelected
            ? data.filter((item: any) => (+item.fahrzeug_tid_orig || null) === fahrzeugSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const { fahrzeugSelected } = this.props;
        // console.log('Fahrzeug: ', fahrzeugSelected);
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_FAHRZEUGE_JAHRESWERTE}
                module={IDs.MOD_ETOOL}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                addLabel='Neues Jahr anlegen'
                formPreset={{ fahrzeug_tid: fahrzeugSelected.tid }}
                customFormConfig={{
                    fahrzeug_tid: {
                        readonly: true
                    },
                    material: {
                        readonly: 0 // Später hier noch anhand des Wertes von material_tid
                    }
                }}
                validateField={this.validateField}
                validRestriction={this.state.validRestriction}
                callBeforeOnFormSave={(data: any, callback: () => void) =>
                    this.setState(
                        { validRestriction: !isValid(data || {}, IDs.ENT_FAHRZEUGE_JAHRESWERTE, null, true) ? 'stop' : null },
                        () => callback()
                    )
                }
                preFilterFunction={this.preFilter}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE_JAHRESWERTE)}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_FAHRZEUGE_JAHRESWERTE, key, value, data, onValueChange);
    }
}
